export default "__VITE_PUBLIC_ASSET__391c3ebe__"